/**
 * @method insertSvgBetweenNodes
 */
const insertSvgBetweenNodes = (frame, markerIndex, start, end) => {
  if (!frame) {
    return;
  }

  const contentDocument = frame.contentDocument;

  let range = contentDocument.createRange();

  if (!end) {
    range.selectNodeContents(start);
  } else {
    const startEl =
      start?.markerPosition !== 'startOfDocument' &&
      contentDocument.getElementById(start);
    const endEl =
      end?.markerPosition !== 'endOfDocument' &&
      contentDocument.getElementById(end);
    if (start?.markerPosition === 'startOfDocument') {
      range.selectNodeContents(endEl);
    } else if (end?.markerPosition === 'endOfDocument') {
      range.selectNodeContents(startEl);
    } else {
      range.setStart(startEl, 0);
      range.setEnd(endEl, 0);
    }
  }

  const temporaryContainer = contentDocument.createElement('div');
  temporaryContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="svgCover" id="svgCover-${markerIndex}"></svg>`;

  let baseRect;

  try {
    baseRect = range.getBoundingClientRect();
  } catch (e) {
    console.warn('Cant find rect container');
    return;
  }

  const svg = temporaryContainer.querySelector(`#svgCover-${markerIndex}`);

  const height =
    end?.markerPosition === 'endOfDocument'
      ? contentDocument.body.offsetHeight - baseRect.top + 50
      : start?.markerPosition === 'startOfDocument'
        ? baseRect.top
        : baseRect.height;

  // get transform and scale value for pdf zoom levels
  const transform = window
    .getComputedStyle(contentDocument.body, ':root')
    .getPropertyValue('transform');
  const scale =
    contentDocument.body.getBoundingClientRect().width /
    contentDocument.body.offsetWidth;

  // append svg and update it's styles
  contentDocument.body.parentElement.appendChild(svg);
  svg.style.position = 'absolute';
  svg.style.top =
    start?.markerPosition === 'startOfDocument' ? 0 : baseRect.top;
  svg.style.left = !end ? baseRect.left : 0;
  svg.setAttribute('width', contentDocument.body.offsetWidth);
  svg.setAttribute('height', height);
  svg.style.transform = scale > 1 ? transform : '';
  svg.style.transformOrigin = 'left top';

  // background color of body so that svg rect matches the theme
  const bgColor = window
    .getComputedStyle(contentDocument.body, ':root')
    .getPropertyValue('--RS__backgroundColor');

  // create rect
  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.style.fill = bgColor ? bgColor : 'white';
  rect.setAttribute('width', contentDocument.body.offsetWidth);
  rect.setAttribute('height', height);

  svg.appendChild(rect);
};

export default insertSvgBetweenNodes;
